'use client';

import { Children, cloneElement, isValidElement, type ReactNode } from 'react';
import { Button, type WebButtonProps } from '@galapagos/design-system/web';
import { ensureSignupStepStyle } from './signup-step-style';

/**
 * v7 Web/Form actions: the step's buttons. A sticky bottom bar on phone
 * widths that sits right under the content when the step is short, inline
 * under the content on desktop. Buttons here span the form
 * column, so a Button child with no width of its own gets `stretch` (no
 * Large-button cap); an explicit width is left alone.
 */
export function FormActions({ children }: { children: ReactNode }) {
  ensureSignupStepStyle();
  return (
    <div className="signup-form-actions">
      {Children.map(children, (child) =>
        isValidElement<WebButtonProps>(child) &&
        child.type === Button &&
        child.props.width === undefined
          ? cloneElement(child, { width: 'stretch' })
          : child,
      )}
    </div>
  );
}
